
import { z } from "zod";

export const customerSchema = z.object({
    cust_name: z
        .string()
        .min(3, "Nama minimal 3 karakter")
        .max(100, "Nama maksimal 100 karakter"),
    cust_nik: z
        .string()
        .min(16, "NIK harus 16 digit")
        .max(16, "NIK harus 16 digit")
        .regex(/^\d+$/, "NIK harus berupa angka"),
    cust_address: z
        .string()
        .min(10, "Alamat minimal 10 karakter")
        .max(255, "Alamat maksimal 255 karakter"),
    cust_email: z
        .string()
        .email("Format email tidak valid")
        .optional()
        .or(z.literal("")),
    cust_phone: z
        .string()
        .min(10, "Nomor telepon minimal 10 digit")
        .max(15, "Nomor telepon maksimal 15 digit")
        .regex(/^\d+$/, "Nomor telepon harus berupa angka"),
});

export type CustomerFormData = z.infer<typeof customerSchema>;